import {useCallback, useEffect, useState} from "react";
import {Button, Empty, Spin} from "antd";
import {useNavigate, useParams} from "react-router-dom";
import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import BackHomeIcon, {PANEL_PATH} from "../../components/icons/BackHome/backhome";
import RetouchCompare from "../../components/retouchReview/RetouchCompare";
import {getRetouchReview} from "../../utils/retouchReviewApi";
import {getRetouchReviewCopy} from "../../utils/retouchReviewCopy";
import {useTranslation} from "../../i18n";
import "./retouchReview.css";

function RetouchReviewAudit() {
    const {id} = useParams();
    const navigate = useNavigate();
    const {locale} = useTranslation();
    const copy = getRetouchReviewCopy(locale);
    const [review, setReview] = useState(null);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(true);
    const load = useCallback(async () => {
        setLoading(true);
        setSelected(null);
        try {
            setReview(await getRetouchReview(id));
        } catch {
            setReview(null);
        } finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        load();
    }, [load]);
    useEffect(() => {
        if (review?.photos?.length && !selected) {
            setSelected(review.photos[0]);
        }
    }, [review, selected]);
    const updatePhoto = (next) => {
        setReview((prev) => ({...prev, photos: prev.photos.map((photo) => photo.id === next.id ? next : photo)}));
        setSelected((prev) => prev?.id === next.id ? next : prev);
    };
    const navigatePhoto = (next) => setSelected(next);
    if (loading) return <><PageTitle><Navigation/></PageTitle><BackHomeIcon to={PANEL_PATH}/>
        <div className="retouch-review-loading"><Spin/></div>
        <Footer/></>;
    if (!review) return <><PageTitle><Navigation/></PageTitle><BackHomeIcon to={PANEL_PATH}/>
        <main className="retouch-review-page"><Empty description={copy.loadFailed}/></main>
        <Footer/></>;
    const stateLabel = {
        active: copy.active,
        deleting: copy.deleting,
        delete_failed: copy.deleteFailed
    }[review.state] || review.state;
    return <><PageTitle><Navigation/></PageTitle><BackHomeIcon to={PANEL_PATH}/>
        <main className="retouch-review-page">
            <header className="retouch-review-page__header"><Button
                onClick={() => navigate("/r/manage")}>← {copy.manage}</Button><h1>{review.albumName}</h1>
                <p>{review.albumPath} · {stateLabel}</p></header>
            {!review.photos?.length && <Empty description={copy.noFiles}/>}{selected &&
            <RetouchCompare photo={selected} photos={review.photos} adminMode role="photographer"
                            authorName={copy.photographer} albumName={review.albumName} onPhotoChanged={updatePhoto}
                            onNavigate={navigatePhoto}/>}</main>
        <Footer/></>;
}

export default RetouchReviewAudit;
